import {createActions} from 'client/framework';

const normalActions = [
  // Question actions
  'TOGGLE_OPTION',
  // Editor options
  'SET_SELECTED_OPTIONS'
];

export default createActions(null, normalActions);
